import { filter } from 'lodash';
import { toMoney } from './filters';
import {
    calculateApplicableDiscountCodes,
    calculateTotalTicketCountApplicableForTicketCountDiscountCodes,
    calculateTotalPriceIncludingDiscount,
    calculateTotalVat,
    calculateTotalPrice
} from './utils';


import {
    discountCodeHumanized
} from './filters';


export default function Summary({ contingents, automaticDiscountCodes, discountCodes }) {
    const totalPrice = calculateTotalPrice(contingents);
    const totalVat = calculateTotalVat(contingents);
    const totalTicketCountApplicableForTicketCountDiscountCodes = calculateTotalTicketCountApplicableForTicketCountDiscountCodes(contingents);
    const applicableDiscountCodes = calculateApplicableDiscountCodes(contingents, automaticDiscountCodes, discountCodes);
    const totalPriceIncludingDiscount = calculateTotalPriceIncludingDiscount(contingents, applicableDiscountCodes);
    const totalDiscount = totalPrice - totalPriceIncludingDiscount;

    return (
        <table className="w-full">
          <tbody>
            <tr>
              <td className="py-2">Zwischensumme</td>
              <td className="py-2 text-right">{toMoney(totalPrice)}</td>
            </tr>
            {/* <tr> */}
            {/*   <td className="py-2">enthält MwSt</td> */}
            {/*   <td className="py-2 text-right">{toMoney(totalVat)}</td> */}
            {/* </tr> */}
            {filter(applicableDiscountCodes, dc => dc.applied_amount).map(dc => (
                <tr key={dc.name}>
                  <td className="py-2">{discountCodeHumanized(dc)}</td>
                  <td className="py-2 text-right">-{toMoney(dc.applied_amount)}</td>
                </tr>
            ))}
            <tr className="font-bold border-t border-t-blue-medium">
              <td className="py-2 pb-4">Gesamtsumme<br/><span className="font-normal text-[11px]">inkl. MwSt</span></td>
              <td className="font-bold text-lg text-right">
                {toMoney(totalPriceIncludingDiscount)}
                {!!totalDiscount && <div className="line-through font-normal text-md">{toMoney(totalPrice)}</div>}
              </td>
            </tr>
          </tbody>
        </table>
    );
}
